import { useMemo } from "react";
import { standingsBanner } from "../../../functions/banners";
import { useTournament } from "../TournamentContext";
import calculateTeamStats from "../../../functions/calculateTeamStats";
import sortGroups from "../../../functions/sortGroups";

const Standings = () => {
  const { tournament, teams, matches } = useTournament();
  const { groups, schedule, headToHead } = tournament;

  const teamStats = useMemo(() => {
    return calculateTeamStats(matches, teams, tournament?.pointsPerWin);
  }, [matches, teams, tournament?.pointsPerWin]);

  const sortedGroups = sortGroups(
    groups,
    schedule,
    matches,
    teamStats,
    headToHead
  );

  if (!schedule || !teams || !teamStats) return null;

  return (
    <section className="w-full flex flex-col items-center mb-6">
      <div className="flex w-full flex-wrap justify-center gap-6 mt-8">
        {Object.entries(sortedGroups)
          .slice()
          .sort()
          .map(([groupId, teamIds]) => (
            <div
              key={groupId}
              className="w-full max-w-lg border rounded-xl shadow overflow-hidden h-full"
            >
              <div className={`${standingsBanner(groupId)} p-3 text-center`}>
                <h3 className="text-xl font-bold text-white">{`Group ${
                  Number(groupId) + 1
                }`}</h3>
              </div>
              <div className="p-1">
                <table className="w-full table-fixed">
                  <thead>
                    <tr className="text-sm sm:text-xs text-stone-500 font-extralight">
                      <th className="w-1/2">Team</th>
                      <th>Pl</th>
                      <th>W</th>
                      <th>D</th>
                      <th>L</th>
                      <th>GD</th>
                      <th>GF</th>
                      <th>GA</th>
                      <th>Pts</th>
                    </tr>
                  </thead>
                  <tbody className="text-center text-sm text-stone-700">
                    {teamIds.map((teamId) => {
                      const stats = teamStats[teamId];
                      const {
                        wins,
                        draws,
                        losses,
                        goalDifference,
                        goalsFor,
                        goalsAgainst,
                      } = stats;

                      const matchesPlayed =
                        stats.wins + stats.draws + stats.losses;

                      return (
                        <tr
                          key={teamId}
                          data-testid={`standings-team-${teamId}`}
                        >
                          <td className="text-wrap truncate">
                            {teams[teamId].name || teamId}
                          </td>
                          <td>{matchesPlayed ?? 0}</td>
                          <td>{wins ?? 0}</td>
                          <td>{draws ?? 0}</td>
                          <td>{losses ?? 0}</td>
                          <td>{goalDifference ?? 0}</td>
                          <td>{goalsFor ?? 0}</td>
                          <td>{goalsAgainst ?? 0}</td>
                          <td className="font-bold">{stats.points ?? 0}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
      </div>
    </section>
  );
};

export default Standings;
